"use client";

import { useLayoutEffect } from "react";

/**
 * Dev-only console warning filter.
 * Silences noisy React DOM warnings we cannot fix inside third-party libs.
 */
const ConsoleWarningFilter = () => {
  useLayoutEffect(() => {
    const originalError = console.error;

    console.error = (...args: any[]) => {
      const concatenated = args
        .map((a) => (typeof a === "string" ? a : ""))
        .join(" ");

      // React's exact wording varies slightly across versions/bundlers.
      // We silence only this dev noise: unknown `networkName` on a DOM element.
      if (
        concatenated.includes("networkName") &&
        concatenated.includes("DOM element")
      ) {
        return;
      }

      originalError(...args);
    };

    return () => {
      console.error = originalError;
    };
  }, []);

  return null;
};

export default ConsoleWarningFilter;

